import { useState } from 'react';
import {
  VegaBox,
  VegaButton,
  VegaButtonCircle,
  VegaCard,
  VegaCheckbox,
  VegaFlex,
  VegaFont,
  VegaInput,
  VegaTooltip,
} from '@globalpayments/vega-react';
import useIframeListener from '../../hooks/useIFrameListener';
import { iFrameMessageTypes } from '../../types/iFrameMessageTypes';
import ReceivedMessage from './components/ReceivedMessage';

import './index.css';

const buildIframeUrl = (host: string, queryParams: string, appendFrameHost: boolean, hostname: string) => {
  const queryString = queryParams ? `?${queryParams}` : '';
  const frameHostQuery = appendFrameHost ? `${queryParams ? '&' : '?'}frameHost=${hostname}` : '';

  return `${host}${queryString}${frameHostQuery}`;
};

const IFrameTesting = () => {
  const [messages, setMessages] = useState<MessageEvent[]>([]);
  const [searchValue, setSearchValue] = useState(import.meta.env.VITE_ONDEMAND_IFRAME_DEFAULT_PARAMS ?? '');
  const [appendFrameHost, setAppendFrameHost] = useState(true);
  const [iframeUrl, setIframeUrl] = useState('');
  const [iFrameKey, setIframeKey] = useState(0);
  const frameHostLabel = `Append "frameHost=${window.location.hostname}" to Frame URL`;

  useIframeListener(iFrameMessageTypes.StatusPage, false, (msg: MessageEvent) => {
    setMessages((prev) => [...prev, msg]);
  });

  return (
    <>
      <VegaFlex direction="col" gap="size-32" margin={{ bottom: 'size-48' }}>
        <VegaCard data-testid="lookup-search-panel" padding="size-24" variant="border">
          <VegaFlex direction="col" gap="size-20">
            <VegaFlex alignItems="center" gap="size-12" justifyContent="space-between">
              <VegaFont as="h2" color="text-secondary" variant="font-h5">
                OnDemand IFrame Load
              </VegaFont>
              <VegaTooltip
                content="Enter valid query parameters to test the iFrame."
                maxWidth={320}
                placement={['left', 'bottom']}
                trigger="hover">
                <VegaButtonCircle
                  icon="fa-solid fa-circle-info"
                  label="About OnDemand IFrame Load"
                  showTooltip={false}
                  size="small"
                  variant="icon-only"
                />
              </VegaTooltip>
            </VegaFlex>
            <VegaInput
              label="Query Params"
              maxLength={500}
              onVegaChange={(event) => setSearchValue(event.detail)}
              prefixIcon="fa-solid fa-magnifying-glass"
              showClearIcon
              value={searchValue}
              valueUpdateTrigger="input"
            />
            <VegaFlex alignItems="center" flexWrap="wrap" gap="size-12">
              <VegaCheckbox
                checked={appendFrameHost}
                className="frameHostCheckbox"
                data-aria-label={frameHostLabel}
                onVegaChange={(event) => setAppendFrameHost(event.detail === true)}>
                Append <code className="frameHostCode">&quot;frameHost={window.location.hostname}&quot;</code> to Frame
                URL
              </VegaCheckbox>
              <VegaFlex className="loadIframeAction" flex="0 0 auto">
                <VegaButton
                  label="Load iFrame"
                  size="small"
                  onVegaClick={() => {
                    setIframeKey(iFrameKey + 1);
                    setIframeUrl(
                      buildIframeUrl(
                        import.meta.env.VITE_ONDEMAND_IFRAME_HOST,
                        searchValue,
                        appendFrameHost,
                        window.location.hostname,
                      ),
                    );
                  }}
                />
              </VegaFlex>
            </VegaFlex>
          </VegaFlex>
        </VegaCard>
      </VegaFlex>
      {iframeUrl && (
        <VegaFlex alignItems="center" direction="col" gap="size-32">
          <div className="iframeResizeContainer">
            <div className="iframeFrame">
              <iframe key={iFrameKey} className="iframe" src={iframeUrl} title="OnDemand iFrame Test"></iframe>
            </div>
          </div>

          {messages.length > 0 && (
            <VegaButton
              label="Clear Messages"
              onVegaClick={() => {
                setMessages([]);
              }}
            />
          )}

          {messages.map(function (data, idx) {
            return <VegaBox key={idx}>{<ReceivedMessage message={data} delay={100 + idx * 40} />}</VegaBox>;
          })}
        </VegaFlex>
      )}
    </>
  );
};

export default IFrameTesting;
